import React from 'react';
import styled from 'styled-components';

const AboutsectionBlock = styled.div`
    border-top:107px solid violet;
    padding:100px 0;
`;

const Aboutsection = () => {
    return (
        <AboutsectionBlock>
            <div className="row">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3165.302917019504!2d127.02464661494716!3d37.50077313565001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca15857ce38dd%3A0xac87641577138f5d!2z6re466aw7Lu07ZOo7YSw7JWE7Lm0642w66-4IOqwleuCqOy6oO2NvOyKpA!5e0!3m2!1sko!2skr!4v1635209997761!5m2!1sko!2skr" width="100%" height="450" style={{border:'0'}} allowfullscreen="" loading="lazy"></iframe>
            </div>
        </AboutsectionBlock>
    );
};

export default Aboutsection;